<template>
  <div>
    <div class="nav-box">
      <div class="item active">个性化定制</div>
    </div>

    <div>
      <h3>什么是定制优惠？</h3>
      <p>1、为您的粉丝/用户定制专属链接或优惠；</p>
      <p>2、可定制优惠套餐，比如买一送一；</p>
      <p>3、定制专属佣金提成；</p>
      <p style="margin-bottom:1rem">4、定制独家活动素材。</p>

      <h3>我要定制优惠</h3>
      <p>1、左侧联系您的私人顾问；</p>
      <p>2、当然您也可以直接发送邮件【定制内容计划以及您的想法】至 support@aiviysoft.com ，我们会很快与你取得联系！</p>
    </div>

    <a-button type="primary" class="mt-1" @click="$router.push('/dashboard/products?nav=diy')">查看我的定制商品</a-button>
  </div>
</template>

<script>
export default {
  name: '',
  data(){
    return {

    }
  },
  mounted(){

  },
  methods:{
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .nav-box{
    display: flex;
    margin-bottom: 40px;
  }
  .nav-box .item{
    position: relative;
    padding-right: 60px;
    cursor: pointer;
  }
  .nav-box .item:hover{
    color: rgba(255, 255, 255, 0.8);
  }
  .nav-box .item.active{
    color: #fff;
  }
  .nav-box .item.active::after{
    content: '';
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 30px;
    height: 2px;
    background: #fff;
  }
</style>
